/*门诊病历打印模板*/
export const Tstore = {
	"panels": [{
		"index": 0,
		"paperType": "A5",
		"height": 148,
		"width": 210,
		"paperHeader": 43.5,
		"paperFooter": 419.52755905511816,
		"printElements": [{
			"options": {
				"left": 187.5,
				"top": 6,
				"height": 30,
				"width": 192,
				"title": "药品验收入库报告单",
				"fontFamily": "SimSun",
				"fontSize": 14.25,
				"fontWeight": "800",
				"textAlign": "center",
				"textContentVerticalAlign": "middle"
			},
			"printElementType": {
				"type": "text"
			}
		}, {
			"options": {
				"left": 411,
				"top": 9,
				"height": 22.5,
				"width": 151.5,
				"title": "入库时间",
				"field": "createTime",
				"textContentVerticalAlign": "middle"
			},
			"printElementType": {
				"type": "text"
			}
		}, {
			"options": {
				"left": 202.5,
				"top": 49.5,
				"height": 24,
				"width": 159,
				"title": "入库编号",
				"field": "docNum",
				"textContentVerticalAlign": "middle"
			},
			"printElementType": {
				"type": "text"
			}
		}, {
			"options": {
				"left": 15,
				"top": 49.5,
				"height": 25.5,
				"width": 147,
				"title": "供货单位",
				"field": "supplierName",
				"textContentVerticalAlign": "middle"
			},
			"printElementType": {
				"type": "text"
			}
		}, {
			"options": {
				"left": 421.5,
				"top": 49.5,
				"height": 24,
				"width": 120,
				"title": "产地",
				"textContentVerticalAlign": "middle"
			},
			"printElementType": {
				"type": "text"
			}
		}, {
			"options": {
				"left": 15,
				"top": 88.5,
				"height": 37.5,
				"width": 550,
				"field": "tableData",
				"tableBorder": "border",
				"columns": [
					[{
						"title": "库存号",
						"field": "invyId",
						"width": 33.78402966471549,
						"colspan": 1,
						"rowspan": 1,
						"checked": true,
						"columnId": "invyId"
					}, {
						"title": "名称",
						"field": "drugName",
						"width": 52.915402090823804,
						"colspan": 1,
						"rowspan": 1,
						"checked": true,
						"columnId": "drugName"
					}, {
						"title": "规格",
						"field": "drugSpec",
						"width": 78.16389161215785,
						"colspan": 1,
						"rowspan": 1,
						"checked": true,
						"columnId": "drugSpec"
					}, {
						"title": "数量",
						"field": "purcCnt",
						"width": 26.75985648652462,
						"colspan": 1,
						"rowspan": 1,
						"checked": true,
						"columnId": "purcCnt"
					}, {
						"title": "单位",
						"field": "pacUnt",
						"width": 26.64784385160047,
						"colspan": 1,
						"rowspan": 1,
						"checked": true,
						"columnId": "pacUnt"
					}, {
						"title": "进价",
						"field": "purcPric",
						"width": 30.510150866700844,
						"colspan": 1,
						"rowspan": 1,
						"checked": true,
						"columnId": "purcPric"
					}, {
						"title": "进价金额",
						"field": "purcAmt",
						"width": 43.44339925947993,
						"colspan": 1,
						"rowspan": 1,
						"checked": true,
						"columnId": "purcAmt"
					}, {
						"title": "售价",
						"field": "salePric",
						"width": 32.69334365978369,
						"colspan": 1,
						"rowspan": 1,
						"checked": true,
						"columnId": "salePric"
					}, {
						"title": "售价金额",
						"field": "saleAmt",
						"width": 38.235383136094555,
						"colspan": 1,
						"rowspan": 1,
						"checked": true,
						"columnId": "saleAmt"
					}, {
						"title": "生产批号",
						"field": "manuLotnum",
						"width": 45.75061265361858,
						"colspan": 1,
						"rowspan": 1,
						"checked": true,
						"columnId": "manuLotnum"
					}, {
						"title": "有效期",
						"field": "expyDate",
						"width": 56.665134615384744,
						"colspan": 1,
						"rowspan": 1,
						"checked": true,
						"columnId": "expyDate"
					}, {
						"title": "生产厂家",
						"field": "prodentpName",
						"width": 84.4309521031154,
						"colspan": 1,
						"rowspan": 1,
						"checked": true,
						"columnId": "prodentpName"
					}]
				]
			},
			"printElementType": {
				"title": "表格",
				"type": "tableCustom"
			}
		}, {
			"options": {
				"left": 15,
				"top": 172.5,
				"height": 24,
				"width": 549,
				"borderStyle": "solid"
			},
			"printElementType": {
				"type": "rect"
			}
		}, {
			"options": {
				"left": 21,
				"top": 177,
				"height": 16.5,
				"width": 120,
				"title": "进价总金额",
				"field": "costAmt",
				"textContentVerticalAlign": "middle"
			},
			"printElementType": {
				"type": "text"
			}
		}, {
			"options": {
				"left": 288,
				"top": 177,
				"height": 16.5,
				"width": 120,
				"title": "售价总金额",
				"field": "saleAmt",
				"textContentVerticalAlign": "middle"
			},
			"printElementType": {
				"type": "text"
			}
		}, {
			"options": {
				"left": 159,
				"top": 213,
				"height": 22.5,
				"width": 82.5,
				"title": "审核人",
				"field": "reviewer",
				"textContentVerticalAlign": "middle"
			},
			"printElementType": {
				"type": "text"
			}
		}, {
			"options": {
				"left": 295.5,
				"top": 213,
				"height": 22.5,
				"width": 97.5,
				"title": "过单人",
				"field": "passOrder",
				"textContentVerticalAlign": "middle"
			},
			"printElementType": {
				"type": "text"
			}
		}, {
			"options": {
				"left": 447,
				"top": 213,
				"height": 22.5,
				"width": 147,
				"title": "打印时间",
				"field": "busDate",
				"textContentVerticalAlign": "middle"
			},
			"printElementType": {
				"type": "text"
			}
		}, {
			"options": {
				"left": 15,
				"top": 213,
				"height": 22.5,
				"width": 94.5,
				"title": "采购人",
				"field": "creater",
				"textContentVerticalAlign": "middle"
			},
			"printElementType": {
				"type": "text"
			}
		}, {
			"options": {
				"left": 15,
				"top": 9,
				"height": 25.5,
				"width": 120,
				"title": "入库库房",
				"field": "shedId",
				"textContentVerticalAlign": "middle"
			},
			"printElementType": {
				"type": "text"
			}
		}],
		"paperNumberLeft": 565,
		"paperNumberTop": 397
	}]
}